export class FinanceiroPlanejamentoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getPlanejamento(params) {
    return this.instance.get('v1/financeiro/planejamento', { params });
  }

  getPlanejamentoAnual(params) {
    return this.instance.get('v1/financeiro/planejamento/anual', { params });
  }

  getAcompanhamentoMensal(params) {
    return this.instance.get('v1/financeiro/acompanhamento-mensal', { params });
  }

  downloadCsvAcompanhamentoMensal(params) {
    return this.instance.get('v1/financeiro/acompanhamento-mensal/download-csv', {
      params,
      responseType: 'blob',
    });
  }

  upsertPlanejamento(data) {
    return this.instance.put('v1/financeiro/planejamento', data);
  }
}

export default (...params) => new FinanceiroPlanejamentoFactory(...params);
